import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import { useSelector } from "react-redux"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import { useDispatch } from "react-redux"
import { GeneralDropDowns } from "../../../../actions/GeneralPatientActions"

const AddNewShift = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Shift')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Shift')?.IsDeleted
    const dispatch = useDispatch();
    // let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Marketer')?.IsDeleted
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        CoordinatorVal: "",
        StartTime: '',
        EndTime: '',
    }
    let Co_ordinator_Modal = {
        ShiftName: "",
        Description: '',
        StartTime: '',
        EndTime: '',
        // IsActive: "",
        UpdatedDate: "",
        // PatientIDs : "",
        UpdatedBy: ""
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let ShiftsDD = DropDowns?.Shifts;
    const [CoordinatorCode, setCoordinatorCodes] = useState()
    const [CoordinatorValidationModal, setCoordinatorValidationModal] = useState(ValidationModal)
    const [CoordinatorSaveUpdateModal, setCoordinatorSaveUpdateModal] = useState({})
    const [mainCoordinatorModal, setmainCoordinatorModal] = useState(Co_ordinator_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenMarketer, onClose, onDeleteCoordinator, type } = { ...props }
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [onCoordinatorsave, setonCoordinatorsave] = useState(false)
    const [patientValue, setPateintValue] = useState([])
    const [PatientDD, setPatientDD] = useState([]);
    const [Patientid, setPatientID] = useState('')
    const [is, setIs] = useState(false);
    const [patientBody, setPatientBody] = useState({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": '' })
    const [Patientname, setPatientName] = useState('');
    const [selectedPatients, setselectedPatients] = useState([])
    const API_URL_Patient = enumUtil.controller.Patient
    useEffect(() => {
        if (props.Marketer != null) {
            setCoordinatorCodes(props.Marketer)
            setDel(true)
        } else {
            if (!onCoordinatorsave) {
                setCoordinatorCodes(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(CoordinatorCode) && CoordinatorCode !== '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": CoordinatorCode,
                "TableName": enumUtil.enumAPITableName.Shifts
            }).then((response) => {
                setIsLoading(false)
                // console.log(response)
                setmainCoordinatorModal(response)
            }).catch((error) => {
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [CoordinatorCode])
    let dataPatient = {
        key: 2,
        active: true,
        name: 'Patient',
        data: {
            id: Patientid,
            name: Patientname,
            time: new Date(),
        }
    };
    const handleMultipleSelect = (value, type) => {
        let arr = [];
        if (type === 'PatientID') {
            value.map((key, index) => {
                arr.push(key.value)
            })
            setPateintValue(value);
        }
        setPatientDD([])
    }

    const handleCOChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainCoordinatorModal };
        let saveModal = { ...CoordinatorSaveUpdateModal }
        modal[name] = value
        setmainCoordinatorModal(modal)
        for (var property in Co_ordinator_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        // if (name === 'PatientIDs') {
        //     setPatientBody({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": value })
        // }
        setCoordinatorSaveUpdateModal(saveModal)
    }

    const handleTimeChange = (e) => {
        const { name, value } = e.target;
        let modal = { ...mainCoordinatorModal };
        let saveModal = { ...CoordinatorSaveUpdateModal };
        modal[name] = value;
        const tempStartTime = name === "StartTime" ? value : modal.StartTime;
        const tempEndTime = name === "EndTime" ? value : modal.EndTime;

        if (tempStartTime && tempEndTime && tempStartTime > tempEndTime) {
            NotificationHandler('Start Time should be less than or equal to End Time.', enumUtil.enumtoaster.warning)
            modal["EndTime"] = "";
            saveModal["EndTime"] = "";
            setmainCoordinatorModal(modal);
            setCoordinatorSaveUpdateModal(saveModal);
            return;
        }
        setmainCoordinatorModal(modal);
        if (Co_ordinator_Modal.hasOwnProperty(name)) {
            saveModal[name] = value;
        }
        setCoordinatorSaveUpdateModal(saveModal);
    };

    const handleAlertTypeChange = (e) => {
        const { name, value } = e.target;
        let modal = { ...mainCoordinatorModal };
        let saveModal = { ...CoordinatorSaveUpdateModal };

        if (name === "IsActive") {
            modal[name] = value === "true";
        }

        setmainCoordinatorModal(modal);

        saveModal[name] = modal[name] ? "true" : "false";
        setCoordinatorSaveUpdateModal(saveModal);
    };


    const CoordinatorValidation = async () => {
        let ValidationModal = {
            CoordinatorVal: FormValidator(
                mainCoordinatorModal.ShiftName,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            StartTime: FormValidator(
                mainCoordinatorModal.StartTime,
                enumUtil.enumValidationType.Required,
                'Start Time',
            ),
            EndTime: FormValidator(
                mainCoordinatorModal.EndTime,
                enumUtil.enumValidationType.Required,
                'End Time',
            )
        }
        await setCoordinatorValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveCordinator = async () => {
        await CoordinatorValidation()
        // setCoordinatorCodes(mainCoordinatorModal.MarketerName)
        // setCoordinatorCodes(CoordinatorCode)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        }
        else {
            // const patientIds = selectedPatients.map(patient => patient.id).join(',')
            setCoordinatorSaveUpdateModal(CoordinatorSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Shifts,
                ID: CoordinatorCode,
                data: {
                    ...CoordinatorSaveUpdateModal,
                    // PatientIDs: patientIds
                },
                // value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        let ShiftsDropdown = DropDowns?.Shifts;
                        if (CoordinatorCode + "" === "0") {
                            // console.log("CoordinatorCode", CoordinatorCode)
                            let newShiftObj = { value: response?.id, display: CoordinatorSaveUpdateModal?.ShiftName };
                            ShiftsDropdown.push(newShiftObj)

                            dispatch(GeneralDropDowns({ ...DropDowns, Shifts: ShiftsDropdown }))

                        }
                        else {
                            ShiftsDropdown.map((item) => {
                                if (item?.value + "" === CoordinatorCode + "") {
                                    item.display = mainCoordinatorModal.ShiftName
                                }
                            })

                            dispatch(GeneralDropDowns({ ...DropDowns, Shifts: ShiftsDropdown }))

                        }
                        // UpdateReduxDropDowns(CoordinatorCode, DropDowns.Marketer, response.id, mainCoordinatorModal.MarketerName)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setCoordinatorCodes(response?.id)
                        setonCoordinatorsave(true)
                        onDeleteCoordinator()
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    if (!isNull(error?.response?.data)) { NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error) }
                    else { NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error) }
                })
        }
    }
    const SetCoName = () => {
        if (mainCoordinatorModal.ShiftName != null && mainCoordinatorModal.ShiftName != "") {
            return (
                <p className="heading">{mainCoordinatorModal.ShiftName}</p>
            )
        } else {
            return (
                <p className="heading">Add New Shift </p>
            )
        }
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainCoordinatorModal };
        // let saveModal = { ...CoordinatorSaveUpdateModal };
        if (type === 'server' && !isNull(selectedData)) {
            if (name === 'PatientIDs' && !isNull(selectedData)) {
                setPatientID(selectedData.value + "");
                setPatientName(selectedData.display);
                const isPatientAlreadyAdded = selectedPatients.some(patient => patient.id === selectedData.value);
                if (!isPatientAlreadyAdded) {
                    setselectedPatients((prevPatients) => [
                        ...prevPatients,
                        {
                            id: selectedData.value,
                            firstName: selectedData.display.split(',')[0],
                            lastName: selectedData.display.split(',')[1]
                        }
                    ]);
                } else {
                    NotificationHandler('Patient is already added.', enumUtil.enumtoaster.warning);
                }
                modal[name] = selectedData.display;
                // saveModal[name] = selectedData.value + "";
            } else {
                setPatientID("");
                setPatientName("");
                modal[name] = ""
                // saveModal[name] = ""
            }
        }

        setmainCoordinatorModal(modal);
        // setCoordinatorSaveUpdateModal(saveModal);
    };
    const removeSelectedPatient = (id) => {
        setselectedPatients((prevPatients) =>
            prevPatients.filter((patient) => patient.id !== id)
        );
    };
    const handleDeleteModal = () => {
        if (IsDeleteAllowed) {
            setisOpenAlert(true)
        }
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed ? 'btn-icon-transparent' : 'btn-icon-transparent disabled'} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Shifts} ID={CoordinatorCode} onClose={onDeleteCoordinator} dropDown={ShiftsDD} />
        // dropDown={DropDowns?.Marketer}
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={CoordinatorCode + ""} TableName={enumUtil.enumAPITableName.Marketer} />
    }
    // useEffect(() => {
    //     console.log("Updated Redux State:", DropDowns["Shifts"]);
    // }, [DropDowns]);
    const AddNewCOModalBody = () => {
        return (
            <>
                <div className="">
                    <div className={CoordinatorValidationModal.CoordinatorVal ? 'form-group input error' : 'form-group input'}>
                        <label htmlFor="POSCode">Name<span className='req'>*</span></label>
                        <div className='form-group input'>
                            <input type="text"
                                className='form-control'
                                name="ShiftName"
                                id="ShiftName"
                                autoComplete="off"
                                value={mainCoordinatorModal.ShiftName}
                                onChange={handleCOChange}
                            />
                            {CoordinatorValidationModal.CoordinatorVal}
                        </div>
                        {/* {/ error helperText="Error Message" /} */}


                    </div>

                    <div className='d-flex mb-12'>
                        <div className="input col-md-6 pe-1">
                            <div className={CoordinatorValidationModal.StartTime ? 'form-group input error' : 'form-group input'}>
                                <label className='text fs-12 ar-light-color'>Start Time</label>
                                <input type="time" className='form-control fc-xs rounded-1'
                                    name="StartTime" id="StartTime" value={mainCoordinatorModal?.StartTime}
                                    onChange={handleTimeChange}

                                />
                            </div>
                            {CoordinatorValidationModal.StartTime}
                        </div>
                        <div className="input col-md-6 ps-1">
                            <div className={CoordinatorValidationModal.EndTime ? 'form-group input error' : 'form-group input'}>
                                <label className='text fs-12 ar-light-color'>End Time</label>
                                <input type="time" className='form-control fc-xs rounded-1'
                                    name="EndTime" id="EndTime" value={mainCoordinatorModal?.EndTime}
                                    onChange={handleTimeChange}
                                />
                            </div>
                            {CoordinatorValidationModal.EndTime}
                        </div>
                    </div>

                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control'
                            name="Description"
                            id="Description"
                            value={mainCoordinatorModal.Description}
                            onChange={handleCOChange}
                        />
                    </div>
                </div>
            </>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            <Modal show={isOpenMarketer} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal ar_copy_claims za_new_marketer">
                {AuditPopup}
                <Modal.Body>
                    <ModalHeader HeaderName={SetCoName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onCoordinatorsave ? onDeleteCoordinator : onClose} key={6118} Name={'Shift'} ID={CoordinatorCode} IsDeleteAllowed={IsDeleteAllowed} />
                    {isLoading ? <Loader /> : null}
                    {AddNewCOModalBody()}
                </Modal.Body>
                <ModalFooter isSaved={onCoordinatorsave ? onDeleteCoordinator : onClose} handleSave={handleSaveCordinator} UpdatedDate={mainCoordinatorModal.UpdatedDate} UpdatedBy={mainCoordinatorModal.UpdatedBy} ID={CoordinatorCode} IsEditAllowed={IsEditAllowed} />
            </Modal>

        </React.Fragment>

    )
}
export default AddNewShift